import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AlertService } from '../../../../../Service/alert.service';
import { NavigationStateService } from '../../../../../Service/navigation-state.service'; // Importar el servicio
import * as bootstrap from 'bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-alertas',
  standalone: true,
  templateUrl: './modal-alertas.component.html',
  styleUrls: ['./modal-alertas.component.scss'],
  imports: [CommonModule]
})
export class ModalAlertasComponent implements OnInit {
  errorMessage: string = '';
  alertMessage: string = '';
  confirmMessage: string = '';
  responseMessage: string = '';
  alertType: string = '';
  confirmAction: () => void = () => {};
  cancelAction: () => void = () => {};

  // NUEVO: propiedades para el modal de copiar enlace
  copiarLinkUrl: string = '';
  showCopiarLinkModal: boolean = false;
  copiado: boolean = false;

  @Output() modalClosed = new EventEmitter<void>();
  @Output() confirmActionEvent = new EventEmitter<void>();
  @Output() cancelActionEvent = new EventEmitter<void>();

  constructor(
    private alertService: AlertService,
    private navigationStateService: NavigationStateService // Inyectar el servicio
  ) {}

  ngOnInit() {
    this.alertService.alertState.subscribe(alert => {
      this.alertType = alert.alertType;
      this.setMessage(alert.alertType, alert.message);
      this.confirmAction = alert.confirmAction || (() => {});
      this.cancelAction = alert.cancelAction || (() => {});
      this.ModalOpen(alert.alertType);
    });
  }

  setMessage(alertType: string, message: string) {
    if (alertType === 'error') {
      this.errorMessage = message;
    } else if (alertType === 'alert') {
      this.alertMessage = message;
    } else if (alertType === 'confirm') {
      this.confirmMessage = message;
    } else if (alertType === 'response') {
      this.responseMessage = message;
    } else if (alertType === 'copiar-link') {
      this.copiarLinkUrl = message;
      this.showCopiarLinkModal = true;
      this.copiado = false;
    }
  }

  ModalOpen(alertType: string) {
    console.log('ModalOpen', alertType);
    let modalElement: HTMLElement | null = null;
    if (alertType === 'error') {
      modalElement = document.getElementById('errorModal');
    } else if (alertType === 'alert') {
      modalElement = document.getElementById('alertModal');
    } else if (alertType === 'confirm') {
      modalElement = document.getElementById('confirmModal');
    } else if (alertType === 'response') {
      modalElement = document.getElementById('responseModal');
    } else if (alertType === 'copiar-link') {
      this.showCopiarLinkModal = true;
      return;
    }

    if (modalElement) {
      modalElement.style.display = 'block';
      modalElement.classList.add('show');
    }
  }

  closeModal(modalId: string) {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      modalElement.style.display = 'none';
      modalElement.classList.remove('show');
      this.alertService.alertClosed(); // Notificar al servicio que la alerta se ha cerrado
      this.modalClosed.emit();
    }
    if (modalId === 'copiarLinkModal') {
      this.showCopiarLinkModal = false;
      this.copiado = false;
      this.alertService.alertClosed();
      this.modalClosed.emit();
    }
  }

  confirmActionHandler() {
    this.confirmAction();
    this.closeModal(this.getModalIdByAlertType(this.alertType));
  }

  cancelActionHandler() {
    const currentUrl = window.location.href;
    this.navigationStateService.triggerUpdateUrl(currentUrl);
    this.closeModal(this.getModalIdByAlertType(this.alertType));
    this.cancelAction();
  }

  // NUEVO: métodos para copiar enlace y cerrar modal
  copiarLinkAlPortapapeles(inputElement: HTMLInputElement) {
    if (this.copiarLinkUrl) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.copiarLinkUrl).then(() => {
          this.copiado = true;
          setTimeout(() => (this.copiado = false), 1500);
        }).catch(() => {
          // Fallback si falla clipboard API
          inputElement.select();
          document.execCommand('copy');
          this.copiado = true;
          setTimeout(() => (this.copiado = false), 1500);
        });
      } else {
        // Fallback para navegadores antiguos
        inputElement.select();
        document.execCommand('copy');
        this.copiado = true;
        setTimeout(() => (this.copiado = false), 1500);
      }
    }
  }

  seleccionarTexto(inputElement: HTMLInputElement) {
    inputElement.select();
  }

  cerrarCopiarLinkModal() {
    this.showCopiarLinkModal = false;
    this.copiado = false;
    this.alertService.alertClosed();
    this.modalClosed.emit();
  }

  descargarDJ() {
    console.log('Descargando DJ...');
    this.confirmAction();
  }

  openDJLink() {
    if (this.copiarLinkUrl) {
      const nueva = window.open(this.copiarLinkUrl, '_blank', 'noopener');
      /*if (!nueva) {
        this.alertService.showAlert(
          'alert',
          'El navegador bloqueó la apertura de la nueva pestaña. Permita pop-ups para continuar.',
          () => {}
        );
      }*/
    }
  }
  private getModalIdByAlertType(alertType: string): string {
    switch (alertType) {
      case 'error':
        return 'errorModal';
      case 'alert':
        return 'alertModal';
      case 'confirm':
        return 'confirmModal';
      case 'response':
        return 'responseModal';
      default:
        return '';
    }
  }
}